export const HasAttachments = ({ props }) => ([
  { text: 'Ja', value: '::true' },
  { text: 'Nein', value: '::false' }
])
